<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: { 
    title: "İşlem Geçmişleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable
  },
  mixins: [ datatableMixin],
  data() {
    return {
      title: "İŞLEM GEÇMİŞLERİ",
      items: [
      {
        text: "ANASAYFA",
        href: "/",
      },
      {
        text: "İŞLEM GEÇMİŞLERİ",
        active: true,
      }],

      searchParams: {},
      columns: [
          { name: 'Kullanıcı Adı', key: 'username', width: 150 },
          { name: 'İsim Soyisim', key: 'fullname', width: 150 },
          { name: 'İşlem Açıklaması', key: 'content', width: 200 },
          { name: 'İşlem Tarihi', key: 'created_at', width: 150 },
          { name: 'İşi Yapan', key: 'name', width: 150 }
      ],
      tableData: {
        detail: true,
        excel: false,
        searchable:{
          visible:true,
          placeholder:"İsim Soyisim ve Kullanıcı Adı Ara"
        }
      },
      endpoint: '/reports/islem-gecmisleri', 

      form:{
          user_id:"",
          startdate:'',
          startdateend:''
      },
      rows: [],
      userList:[],
    };
  },
  mounted() { this.getUsers() },
  methods: {
    getUsers(){
        this.$http.post('/users?output=one&fields=id,name')
        .then(response => {
            this.userList = [
                { id: "", name: 'Tümü' },
                ...response.data
            ];
        })
    },
    
    async loadPage() {
      this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
      
      const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
      if (this.params.page === 1) {
          this.tableData.data = response.data.data;
      } else {
          this.tableData.data = [...this.tableData.data, ...response.data.data];
      } 

      response.data.data.forEach(item => {
        if(item.invoice_num){
          this.nfnum[item.id] = item.invoice_num;
        }
      });

      this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
      this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
    },
    handleFilterChange() {
      this.searchParams = this.form
      this.loadPage()
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <Datatable 
        :columns="columns" 
        :tableData="tableData" 
        @sort-column="handleSortColumn"
        @search-query="reLoadPage"
        @excel-export="excelExport"
        :loading="isLoading"
        :poading="pageLoading">
          
          <template #created_at="{ row }">
               {{ formatDate(row.created_at, 'DD.MM.YYYY HH:mm')  }}
          </template>

          <template #fullname="{ row }">
            <span v-b-popover.hover.auto="row.fullname">{{ row.fullname }}</span>
          </template>

          <template #content="{ row }">
            <span v-b-popover.hover.auto="row.content">{{ row.content }}</span>
          </template>

          <template #searchItems="{ row }">
            <div class="col-md-4">
                  <div class="mb-3">
                    <label>İşlemi Yapan</label>
                    <v-select
                       @input="handleFilterChange"
                        label="name" 
                        v-model="form.user_id"
                        :options="userList" 
                        :reduce="data => data.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                  </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-xl-8">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label class="d-flex justify-content-between">İşlem Tarih Aralığı
                        <span 
                          v-if="form.startdate || form.startdateend" 
                          class="text-danger" 
                          @click="form.startdate= '' ;form.startdateend= '';handleFilterChange()">
                          temizle</span>
                        </label>
                      <div class="input-group">
                        <input type="date" class="form-control"  v-model="form.startdate" @change="handleFilterChange">
                        <button style="border:0;background: transparent;">  - </button>
                        <input type="date" class="form-control"  v-model="form.startdateend" @change="handleFilterChange">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </template>
     </Datatable>
</Layout>
</template>